export default {
  smartHomeDevices: [],
  smartHomeDeviceStatuses: [],
};
